/**
 * Personal email domains that are not allowed for signup (work email only).
 */
export const BLOCKED_EMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "ymail.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "comcast.net",
  "att.net",
  "sbcglobal.net",
  "verizon.net",
  "earthlink.net",
  "gmx.com",
  "gmx.de",
  "free.fr",
  "laposte.net",
  "wanadoo.fr",
  "orange.fr",
  "uol.com.br",
  "bol.com.br",
  "yandex.ru",
  "mail.ru",
  "proton.me",
];

export const extractDomain = (email: string): string => {
  const parts = email.trim().toLowerCase().split("@");
  if (parts.length !== 2) return "";
  return parts[1];
};

export const isDomainBlocked = (email: string): boolean => {
  const domain = extractDomain(email);
  if (!domain) return false;
  return BLOCKED_EMAIL_DOMAINS.includes(domain);
};

/** Returns the blocked domain if the email uses one, otherwise null. Use for error messages. */
export const getBlockedDomain = (email: string): string | null => {
  const domain = extractDomain(email);
  if (!domain) return null;
  return BLOCKED_EMAIL_DOMAINS.includes(domain) ? domain : null;
};
